module.exports = __webpack_public_path__ + "img/logoproduempak.56237fe8.png";